export default __webpack_public_path__ + "static/media/User.06a9e3b0.svg";